import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Params, ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { EmailListEntryDto } from '@coin/importer/dto/util';
import { PopupAction } from '@coin/importer/core/util';
import { SimpleTableHeader, SimpleTableComponent } from '../../simple-table/simple-table.component';
import { EmailListEntryPopupComponent } from '../email-list-entry-popup/email-list-entry-popup.component';
import { EmailListService } from '../../../services/organisation-management/email-list.service';
import { AsyncPipe, DatePipe } from '@angular/common';
import { V2ButtonComponent } from '@coin/shared/core/ui-storybook';

@Component({
  selector: 'importer-email-list',
  templateUrl: './email_list.component.html',
  styleUrls: ['./email_list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [V2ButtonComponent, SimpleTableComponent, AsyncPipe, DatePipe]
})
export class EmailListComponent {
  emailListService = inject(EmailListService);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly matDialog = inject(MatDialog);

  public queryParameters$: Observable<Params> = this.route.queryParamMap;
  public updaterIntervalInMs = null;
  public selectedTableHeaders: SimpleTableHeader[] = [
    {
      title: 'Edit',
      width: '50px'
    },
    {
      title: 'Delete',
      width: '50px'
    },
    {
      title: 'Gid',
      key: 'Gid',
      filterType: 'input'
    },
    {
      title: 'Email Address',
      key: 'EmailAddress',
      filterType: 'input'
    },
    {
      title: 'Created at',
      key: 'CreatedAt',
      filterType: 'date'
    },
    {
      title: 'Created by Gid',
      key: 'CreatedByGid',
      filterType: 'input'
    },
    {
      title: 'Last modified at',
      key: 'LastModifiedAt',
      filterType: 'date'
    },
    {
      title: 'Last modified by Gid',
      key: 'LastModifiedByGid',
      filterType: 'input'
    }
  ];

  openCreateEmailListEntryPopup(): void {
    this.matDialog.open(EmailListEntryPopupComponent, {
      data: { action: PopupAction.New, item: {} }
    });
  }

  openUpdateEmailListEntryPopup(item: EmailListEntryDto): void {
    this.matDialog.open(EmailListEntryPopupComponent, {
      data: { action: PopupAction.Edit, item }
    });
  }

  openDeleteEmailListEntryPopup(item: EmailListEntryDto): void {
    this.matDialog.open(EmailListEntryPopupComponent, {
      data: {
        action: PopupAction.Delete,
        item
      }
    });
  }
}
